import type { IntlShape } from 'react-intl';
import type { SubscriptionFeature } from '@alltrails/types/SubscriptionFeature';
import corosSrc from './images/send-to-coros-thumb.avif';

const connectGarminCoros = (intl: IntlShape): SubscriptionFeature => ({
  headline: intl.formatMessage({ defaultMessage: 'Connect Garmin & COROS' }),
  subheadline: intl.formatMessage({
    defaultMessage: 'Sync your wearable to AllTrails to get routes on your wrist, track your activities, and more'
  }),
  thumbnailImage: corosSrc.src
});

export default connectGarminCoros;
